<template>
  <div class="loading">
    <slot><i class="loading-1" /><i class="loading-2" /><i class="loading-3" /></slot>
  </div>
</template>
<script>
  export default {
    name: 'BaseLoading',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        dialog: false,
      }
    },
    watch: {
      value (val) {
        this.dialog = val
      },
      dialog (val) {
        if (!val) {
          this.$emit('input', false)
        }
      }
    },
  }
</script>
